import React from "react";
import { Booking } from "../Interface";
import TimerList from "@/constants/TimerList";
import { format, parseISO } from "date-fns";
import { toZonedTime } from "date-fns-tz";
import { ShowIcon } from "@/utils/svgs";
import { FiEdit2 } from "react-icons/fi";
import { EVENT_TYPE_DATA } from "@/constants/Events";
import { timeToAmPm } from "@/helpers/TimeFormat";
import { convertCentsToDollars, getTimeDifference } from "@thdinc/hpf-shared";

interface EventsTableProps {
    pastEvents: Booking[];
    isPast?: boolean;
    openDetailView: (bookingId: string, is_quote_booking?: boolean, isUpcomingEvent?: boolean) => void;
}

const EventsTable: React.FC<EventsTableProps> = ({
    pastEvents,
    isPast,
    openDetailView,
}) => {
    return (
        <div>
            {pastEvents.length > 0 && (
                <div className="relative overflow-x-auto  rounded-2xl mt-4 overflow-y-auto max-h-full ">
                    <table className="w-full text-sm text-left rtl:text-right text-gray-500">
                        <thead className="text-xs text-gray-700 uppercase bg-[#fcfdfd]">
                            <tr>
                                <th scope="col" className="px-2 sm:px-4  py-3">
                                    Event DATE
                                </th>
                                <th scope="col" className="px-2 sm:px-4  py-3">
                                    Name
                                </th>
                                <th scope="col" className="px-2 sm:px-4  py-3">
                                    BOOKING TYPE
                                </th>
                                <th scope="col" className="px-2 sm:px-4  py-3">
                                    TYPE
                                </th>
                                <th scope="col" className="px-2 sm:px-4  py-3">
                                    Package Amount
                                </th>
                                <th scope="col" className="px-2 sm:px-4  py-3">
                                    Alcohol Spend
                                </th>
                                <th scope="col" className="px-2 sm:px-4  py-3"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {pastEvents.map((item: Booking, index) => {
                                return (
                                    <tr key={index} className="bg-white 0  border-b">
                                        <td className="px-2 sm:px-4 py-4  min-w-36">
                                            <div className="cursor-pointer flex gap-3">
                                                <div>{format(parseISO(item.start_time), "PPP")}</div>
                                            </div>
                                        </td>
                                        <td className="px-2 sm:px-4 py-4 min-w-44">
                                            {`${item?.first_name} ${item.last_name}`}
                                        </td>
                                        <td className="px-2 sm:px-4 py-4 min-w-44">
                                            {`${item.is_quote_booking ? 'Custom Quote' : 'Standard'}`}
                                        </td>
                                        <td className="px-2 sm:px-4 py-4  min-w-36">
                                            <div className="cursor-pointer flex gap-3">
                                                <p>
                                                    {" "}
                                                    {EVENT_TYPE_DATA &&
                                                        EVENT_TYPE_DATA.find(
                                                            (a: any) => a.value === item?.eventtype
                                                        )?.name}
                                                </p>
                                            </div>
                                        </td>
                                        <td className="px-2 sm:px-4 py-4  min-w-36">
                                            <div className="cursor-pointer flex gap-3">
                                                <p>  {item.service_total == 0 ? "-" : convertCentsToDollars(item.service_total.toString())}</p>
                                            </div>
                                        </td>
                                        <td className="px-2 sm:px-4 py-4  min-w-36">
                                            <div className="cursor-pointer flex gap-3">
                                                <div>{item?.product_total == 0 ? "-" : convertCentsToDollars(item?.product_total.toString())}</div>
                                            </div>
                                        </td>
                                        <td className="px-2 sm:px-4 py-4  w-full flex gap-8 items-center justify-between  ">
                                            <div
                                                className="cursor-pointer flex gap-3 bg-p-gray rounded-full p-2 "
                                                onClick={() => openDetailView(item.id, item.is_quote_booking, false)}
                                            >
                                                <FiEdit2 size={14} />
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default EventsTable;
